export default __webpack_public_path__ + "static/media/logo.eec6cc81.png";